/* eslint-env browser */
export const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export function scrollToDOMElement(node) {
  if (node) node.scrollIntoView();
}

export default {
  isSafariBrowser,
  scrollToDOMElement
};



// WEBPACK FOOTER //
// ./src/pages/resources/utils/dom/client.js